import React, {Component} from 'react';
import queryString from 'query-string';
import {resetPasswordConfirm, resourceCustomUsers} from '../../constants';
import {Redirect} from 'react-router-dom';
import {NotificationManager} from 'react-notifications';
import {compose} from 'redux';
import {withTranslation} from 'react-i18next';
import {simpleDataProvider} from '../../fetchApi';
import {FETCH} from '../../fetchApi/types';
import Callback from '../Callback/CallbackSpinner';

const statuses = {
    INITIALIZED: 'initialized',
    LOADING: 'loading',
    FINISHED: 'succeed',
};

class ResetPasswordConfirm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: statuses.INITIALIZED
        };
    }

    verify = () => {
        const {t: translate} = this.props;
        const queryParams = queryString.parse(this.props.location.search, {ignoreQueryPrefix: true});

        if (queryParams.token) {
            this.setState({
                status: statuses.LOADING
            });

            simpleDataProvider(
                FETCH,
                `${resourceCustomUsers}/${resetPasswordConfirm}`,
                {
                    token: queryParams.token
                }
            )
                .then(() => {
                    NotificationManager.success(translate('changePasswordConfirm.passwordChangedSuccessfully'));
                    this.setState({
                        status: statuses.FINISHED
                    });
                })
                .catch(err => {
                    NotificationManager.error(err.message);
                    this.setState({
                        status: statuses.FINISHED
                    });
                });
        } else {
            this.setState({
                status: statuses.FINISHED
            });
        }
    };

    componentDidMount() {
        const {status} = this.state;
        if (status === statuses.INITIALIZED) {
            this.verify();
        }
    }

    render() {
        const {status} = this.state;

        switch (status) {
            case statuses.FINISHED:
                return <Redirect to='/' />;
            default:
                return <Callback />;
        }
    }
}

const EnhancedResetPasswordConfirm = compose(
    withTranslation(),
)(ResetPasswordConfirm);

export default EnhancedResetPasswordConfirm;